'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = require('rp-cookie');

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUTMLast() {
    return _rpCookie2.default.sharedPermanent.get(_constants.COOKIE_UTM_KEY_LAST);
}

exports.default = getUTMLast;


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/~/rp-analytics/lib/utils/cookie/getUTMLast.js
// module id = 1886
// module chunks = 1